import { calculatorHTMItemValues } from '../../../shared/constants/calculator_htm_item.constant';
import { CalculatorOptions } from '../../../shared/classes/CalculatorOptions';

export type CalculatorInputFieldsKey = typeof CalculatorInputFields[number]['key'];

export type CalculatorInputFieldsType = Record<CalculatorInputFieldsKey, number | null>;

type CalculatorInputOptionType = Partial<Record<CalculatorInputFieldsKey, CalculatorOptions>>;

export const CalculatorInputFields = [
    {
        key: 'average_number_scans',
        label: 'Average number of scans per day',
        defaultValue: 16,
    },
    {
        key: 'average_rembursement',
        label: 'Average reimbursement per exams',
        defaultValue: 1075,
    },
    {
        key: 'high_examination_mix_price',
        label: 'High Price',
        defaultValue: 3000,
    },
    {
        key: 'medium_examination_mix_price',
        label: 'Medium Price',
        defaultValue: 1500,
    },
    {
        key: 'low_examination_mix_price',
        label: 'Low Price',
        defaultValue: 350,
    },
    {
        key: 'high_examination_mix_percent',
        label: 'Mix %',
        defaultValue: 10,
    },
    {
        key: 'medium_examination_mix_percent',
        label: 'Mix %',
        defaultValue: 40,
    },
    {
        key: 'low_examination_mix_percent',
        label: 'Mix %',
        defaultValue: 50,
    },
    {
        key: 'facility_opening_hours',
        label: 'Facility opening hours',
        defaultValue: 8,
    },
    {
        key: 'facility_opening_days',
        label: 'Facility opening in days per year',
        defaultValue: 300,
    },
    {
        key: 'percent_exam_event',
        label: '% of Exams rescheduled after an event',
        defaultValue: 80,
    },
    {
        key: 'radiologist',
        label: '# of Radiologist(s)',
        defaultValue: 1,
    },
    {
        key: 'technologist',
        label: '# of Technologist(s)',
        defaultValue: 1,
    },
    {
        key: 'rate_HTM_org_perfomance',
        label: 'How would you rate your HTM org performance',
        defaultValue: calculatorHTMItemValues[0]['code'],
    },
    {
        key: 'technologist_wages_per_hour',
        label: 'Technologist Wages per hour',
        defaultValue: 150,
    },
    {
        key: 'radiologist_wages_per_hour',
        label: 'Radiologist Wages per hour',
        defaultValue: 250,
    },
    {
        key: 'inHouse_engineer_cost',
        label: 'InHouse Engineer cost per hour',
        defaultValue: 200,
    },
    {
        key: 'admin_fee_rescheduledPatient',
        label: 'Admin fee per rescheduled patient',
        defaultValue: 40,
    },
    {
        key: 'technologist_overtime_percent',
        label: 'Technologist overtime percent',
        defaultValue: 25,
    },
    {
        key: 'radiologist_overtime_percent',
        label: 'Radiologist overtime percent',
        defaultValue: 25,
    },
] as const;

export const CalculatorInputOptions: CalculatorInputOptionType = {
    percent_exam_event: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        }
    },
    rate_HTM_org_perfomance: {
        valueList: [
            ...calculatorHTMItemValues
        ],
        isHTMMode: true
    },
    technologist_overtime_percent: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        }
    },
    radiologist_overtime_percent: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        }
    },
    technologist_wages_per_hour: {
        displayCurrency: true,
    },
    radiologist_wages_per_hour: {
        displayCurrency: true
    },
    inHouse_engineer_cost: {
        displayCurrency: true,
        isHTMMode: true
    },
    admin_fee_rescheduledPatient: {
        displayCurrency: true
    },
    high_examination_mix_price: {
        displayCurrency: true
    },
    medium_examination_mix_price: {
        displayCurrency: true
    },
    low_examination_mix_price: {
        displayCurrency: true
    },
    high_examination_mix_percent: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        }
    },
    medium_examination_mix_percent: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        }
    },
    low_examination_mix_percent: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        }
    }
}

export const CalculatorInputFieldsValues: CalculatorInputFieldsType = CalculatorInputFields.reduce((prev, curr) => {
    return {
        ...(prev || {}),
        [curr.key]: curr.defaultValue
    };
}, {}) as CalculatorInputFieldsType;
